module.exports = __webpack_public_path__ + "img/catalog_stores.fa51519b.svg";